module.exports = __webpack_public_path__ + "static/media/notificationIcon.422170c3.svg";